import { Tag } from "antd";
import React from "react";

export const Balanco: React.FC<React.ComponentProps<typeof Tag>> = (props) => {
    let s = props.children?.toString();
    const v = Number(s?.replace(/[^0-9.-]+/g,""));

    if(isNaN(v)) return props.children;
    return <Tag color={v < 0 ? "red" : "green"} style={{ width: "fit-content" }} {...props} />;
}